import React, {useState, useEffect} from 'react'
import * as S from "../../styles/ezev-fx-styles/LandingPage-styles";

function GroupDownloadPdf(props){
  const [disabledButton, setDisabledButton] = useState(true);
  
  function handleButtonClick() {
    props.openModal()
    setTimeout(() => {
      props.setDisplayPdfTooltip(false)
    }, [5000])
  }

   useEffect(() => {
     if(props.dataLoading || !props.energyGraphData) {
      setDisabledButton(true);
    } else {
      setDisabledButton(false);
    }
  },[props.energyGraphData, props.dataLoading])

  return(
    <S.PdfDownloadContainer>
      {props.displayPdfTooltip &&
      <S.PdfMessageToolTip>
        PDF is compiling and will download when ready. You may navigate through the rest of the product during this time.
      </S.PdfMessageToolTip>
      }
      <S.TableDownloadLink
        onClick={handleButtonClick}
        href={props.link}
        disabled={disabledButton}
        data-testid="pdfDownload-testid"
      >
        Download PDF
      </S.TableDownloadLink>
    </S.PdfDownloadContainer>
  );
}

export default GroupDownloadPdf;
